// Thin GA4 wrapper over Firebase Analytics (measurement id G-MRLY2WKXE9, the shared
// nerdle property). All labs events are `labs_`-prefixed so they're distinguishable
// from other nerdle games in the shared property. Fails silently if analytics isn't
// available (e.g. blocked, or an unsupported context).
import { logEvent, setUserProperties } from 'firebase/analytics'
import { analytics } from '../../index'

type Params = Record<string, string | number | boolean>

export function track(event: string, params?: Params): void {
  try {
    logEvent(analytics, event as string, params)
  } catch {
    /* analytics unavailable — ignore */
  }
}

// Set once per session; every subsequent event carries these (join key to BigQuery
// traces via labs_session_id, and segmentation by engine).
export function setLabsUser(props: Params): void {
  try {
    setUserProperties(analytics, props)
  } catch {
    /* ignore */
  }
}
